import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Products } from "@/components/Products";
import { About } from "@/components/About";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import SignatureGenerator from "@/components/SignatureGenerator";
import Resources from "@/components/Resources";
import BusinessCardGenerator from "@/components/BusinessCardGenerator";
import AxiomPage from "@/pages/AxiomPage";
import ArtPage from "@/pages/ArtPage";
import TrueNorthPage from "@/pages/TrueNorthPage";
import { usePageMeta } from "@/hooks/usePageMeta";

const ScrollToHash = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 150);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Home = () => {
  usePageMeta({ path: "/" });
  return (
    <main>
      <Navbar />
      <Hero />
      <Products />
      <About />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 1 }}>
      <div className="App bg-navy min-h-screen">
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/axiom" element={<AxiomPage />} />
            <Route path="/art" element={<ArtPage />} />
            <Route path="/truenorth" element={<TrueNorthPage />} />
            <Route path="/signature" element={<SignatureGenerator />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/card-generator" element={<BusinessCardGenerator />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </ReactLenis>
  );
}

export default App;
